var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "component-body full-size" }, [
    _c("nav", [
      _c(
        "ul",
        _vm._l(_vm.menu, function(item) {
          return item.exibir !== false
            ? _c(
                "div",
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        id: "tooltip",
                        effect: "dark",
                        content: item.nome,
                        disabled:
                          item.nome.length < 26 && _vm.windowWidth > 1365,
                        placement: "right"
                      }
                    },
                    [
                      _c(
                        "li",
                        {
                          staticClass: "menu-item",
                          class: {
                            active:
                              _vm.$route.meta.routeGroup == item.routeGroup
                          },
                          attrs: { id: "menu-side-" + item.routeName },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.goTo(item.routeName, item.params)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "menu-group" }, [
                            _c("i", {
                              staticClass: "menu-icon fal",
                              class: item.icon
                            }),
                            item.nome.length > 25
                              ? _c("div", { staticClass: "menu-text" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(item.nome.slice(0, 35)) + "..."
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            item.nome.length <= 25
                              ? _c("div", { staticClass: "menu-text" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(item.nome.slice(0, 25)))
                                  ])
                                ])
                              : _vm._e()
                          ])
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79f86886", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79f86886","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideMenu.vue
// module id = null
// module chunks = 